<template>
	<v-container class="pa-1">
		<v-row no-gutters class="rounded-md pa-2">
			<v-col cols='12' md="3" id="sortition-information" style="vertical-align: middle">
				<v-row class="fill-height" no-gutters align-content="center">
					<v-col cols="auto">
						<slot name="name" :sortition="result.sortition">
							<h4>{{ result.sortition.name }}</h4>
						</slot>
						<h4>
							{{ result.date }}
						</h4>
					</v-col>
				</v-row>
			</v-col>
			<v-col cols="12" md="9">
				<v-row no-gutters justify="center">
					<v-col cols="auto">
						<v-row v-if='result.first || result.second || result.third' justify='center' no-gutters>
							<v-col cols='auto' class='d-flex align-center'>
								<h4 class="mx-1">
									1st
								</h4>
								<digit-image-display display-as-one class='d-flex' :digit='result.first'
																		 :image-dimensions='imageDimensions'/>
							</v-col>
							<v-col cols='auto' class='d-flex mx-2 align-center'>
								<h4 class="mx-1">
									2nd
								</h4>
								<digit-image-display display-as-one class='d-flex' :digit='result.second'
																		 :image-dimensions='imageDimensions'/>
							</v-col>
							<v-col cols='auto' class='mx-1 d-flex align-center'>
								<h4 class="mx-1">
									3rd
								</h4>
								<digit-image-display display-as-one class='d-flex' :digit='result.third'
																		 :image-dimensions='imageDimensions'/>
							</v-col>
						</v-row>
						<v-row v-if='result.pickTwo' no-gutters>
							<v-col cols='12' md="auto" class="d-flex align-center">
								<v-img v-if='pickTwoImage' v-bind="pickTwoImage"></v-img>
								<span v-else class='font-weight-bold text-uppercase text-h6'>PICK 3</span>
								<digit-image-display class='d-flex ml-3' :digit='result.pickTwo' :image-dimensions='imageDimensions'/>
							</v-col>
						</v-row>
						<v-row v-if='result.cashThree' no-gutters>
							<v-col cols='12' md="auto" class="d-flex align-center">
								<v-img v-if='pickThreeImage' v-bind="pickThreeImage"></v-img>
								<span v-else class='font-weight-bold text-uppercase text-h6'>PICK 3</span>
								<digit-image-display class='d-flex ml-3' :digit='result.cashThree' :image-dimensions='imageDimensions'/>
							</v-col>
						</v-row>
						<v-row v-if='result.pickFour' no-gutters>
							<v-col cols='12' md="auto" class="d-flex align-center">
								<v-img v-if='pickFourImage' v-bind="pickFourImage"></v-img>
								<span v-else class='font-weight-bold text-uppercase text-h6'>PICK 4</span>
								<digit-image-display class='d-flex ml-3' horizontal :digit='result.pickFour' :image-dimensions='imageDimensions'/>
							</v-col>
						</v-row>
						<v-row v-if='result.pickFive' no-gutters>
							<v-img v-if='pickFiveImage' v-bind="pickFiveImage"></v-img>
							<span v-else class='font-weight-bold text-uppercase text-h6'>PICK 5</span>
							<digit-image-display class='d-flex ml-3' horizontal :digit='result.pickFive' :image-dimensions='imageDimensions'/>
						</v-row>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import DigitImageDisplay from '@/homepage/components/DigitImageDisplay.vue';
import ResultDisplay from '@homepage/components/ResultDisplay.js';

export default {
	name: 'ResultHorizontalDisplay',
	extends: ResultDisplay,
	components: {
		DigitImageDisplay
	}
};
</script>

<style scoped>
@media screen and (min-width: 1280px) {
	#sortition-information {
		border-right: 1px solid white;
	}
}
</style>
